const staticCollectionRootEl = document.getElementById('staticCollectionApp');
const staticProductComponent = {
    data() {
        return {
            imageRatio: '1'
        }
    },
    created() {
    },
    template: `<a v-bind:href="product.url">
                <span class="product-image">
                    <img :src=product.img_url :alt="product.img_alt" loading="lazy">
                </span>
                <span class="item-name"><span class="link-view">{{product.title}}</span></span>
                <span class="item-description" v-html="product.description"></span>
                <span class="add-to-links"><span class="product-button">Choose Options</span></span>
              </a>`,
    props: {
        product: Object
    },
    computed: {
    },
    methods: {}
}
if(staticCollectionRootEl) {
    const staticCollectionApp = Vue.createApp({
        components: {
            'product': staticProductComponent,
        },
        data() {
            return {
                loading: false,
                products: [],
                cards: []
            }
        },
        provide() {
            return {
                loading: Vue.computed(() => this.loading)
            }
        },
        created() {

        },
        mounted () {
            this.loading = true;
            try {
                this.cards = window.limitlesswallsCards || [];
                this.products = JSON.parse(document.getElementById('product-data').textContent);
                //this.observeGrid();
                this.loading = false;
            } catch (e) {
                console.error(e)
            }
        }
    }, { ...staticCollectionRootEl.dataset })
    staticCollectionApp.use(AdobeClientPlugin).use(store);
    staticCollectionApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('swatches')
    staticCollectionApp.config.unwrapInjectedRef = true
    staticCollectionApp.mount('#staticCollectionApp');
}
